export const RECEIVE_USERINFO = 'receive_userinfo' // 接收用户详细信息
export const RECEIVE_USERBASEINFO = 'receive_userbaseinfo' // 接收用户基本信息
export const RECEIVE_COUPONAMOUNT = 'receive_couponamount' // 接收优惠券价格
export const RECEIVE_ADDRESSINFO = 'receive_addressinfo' // 接收地址信息
export const RECEIVE_PASSENGERINFO = 'receive_passengerinfo' // 接收乘客信息
export const RECEIVE_PATIENTINFO = 'receive_patientinfo' // 接收就诊人信息
export const RECEIVE_EXPRESSINFO = 'receive_expressinfo' // 接收快递信息
export const RECEIVE_TICKETINFO = 'receive_ticketinfo' // 接收票务信息
export const RECEIVE_OTHERRINFO = 'receive_otherinfo' // 接收其他信息
export const RECEIVE_ORDERINFO = 'receive_orderinfo' // 接收订单信息
export const RECEIVE_BALANCEPAY = 'receive_balancepay' // 余额支付
export const RECEIVE_FEE = 'receive_fee' // 服务费和夜间费用
export const RECEIVE_ADDFEE = 'receive_addfee' // 服务费和夜间费用
export const RECEIVE_BUDGET = 'receive_budget' // 预算费
export const RECEIVE_EXPRESSTYPE = 'receive_expresstype' // 快递类型
export const RECEIVE_DOCTORINFO = 'receive_doctorinfo' // 医生信息
export const RECEIVE_HOSPITALINFO = 'receive_hospitalinfo' // 医院信息
export const RECEIVE_PAYTYPE = 'receive_paytype' // 支付方式



// WEBPACK FOOTER //
// ./src/store/mutation-type.js